<button type="button" matButton="outlined" class="property-trigger text-start" cdkOverlayOrigin #origin="cdkOverlayOrigin" (click)="toggle()">
  <span class="property-trigger-label">{{ triggerLabel() }}</span>
  <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayPositions]="overlayPositions"
  (backdropClick)="close()"
  (detach)="close()">
  <div class="property-tree-panel mat-elevation-z4">
    <mat-tree [dataSource]="nodes()" [treeControl]="treeControl">
      <mat-nested-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
        <div class="d-flex align-items-center">
          @if (node.isLeaf) {
            <button type="button" matButton class="w-100 text-start" [class.selected]="isSelected(node)" (click)="selectLeaf(node)">
              {{ node.name }}
            </button>
          } @else {
            <button type="button" matIconButton matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
              <mat-icon>{{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}</mat-icon>
            </button>
            <span>{{ node.name }}</span>
          }
        </div>
        <div role="group" [class.d-none]="!treeControl.isExpanded(node)">
          <ng-container matTreeNodeOutlet></ng-container>
        </div>
      </mat-nested-tree-node>
    </mat-tree>
  </div>
</ng-template>
